// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format24 } from '../../constants';

/** Chile */
const CL: PhoneNumberData = [56, 'CL', 9, format24];

export default CL;
